module.exports = __webpack_public_path__ + "img/down.bac2c88a.png";